function getAffiliateURL(tokenId) {
  return `${process.env.REACT_APP_FRONT_PERTIX}?affiliate=${tokenId}`;
}

const affiliateHelpers = {
  getAffiliateURL,
};

export default affiliateHelpers;
